import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExchangeTag from '../../../../Common/ExchangeTag';

/**
 * Compact Index Card for the 'All Indices' tab.
 * Displays real-time price info and daily movement.
 */
const IndexCard = ({ data }) => {
  const { 
    trading_symbol, 
    symbol, 
    exchange, 
    ltp = 0, 
    change = 0, 
    pct = 0 
  } = data;

  const isPositive = change >= 0;
  const name = trading_symbol || symbol || 'UNKNOWN';

  return (
    <Paper 
      elevation={0}
      sx={{ 
        p: 2, 
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          borderColor: 'primary.main',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography variant="subtitle2" fontWeight="700" noWrap sx={{ mb: 0.5 }}>
          {name}
        </Typography>
        <ExchangeTag exchange={exchange} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 0.5, flexWrap: 'wrap' }}>
        <Typography variant="subtitle1" fontWeight="700" noWrap sx={{ fontSize: { xs: '0.95rem', sm: '1.1rem', lg: '1.25rem' } }}>
          ₹{ltp > 0 ? ltp.toFixed(2) : '—'}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', color: isPositive ? 'success.main' : 'error.main', flexShrink: 0 }}>
          {isPositive ? <ArrowDropUpIcon sx={{ fontSize: { xs: 18, lg: 24 } }} /> : <ArrowDropDownIcon sx={{ fontSize: { xs: 18, lg: 24 } }} />}
          <Typography variant="caption" fontWeight="600" noWrap sx={{ fontSize: { xs: '0.6rem', sm: '0.7rem', lg: '0.75rem' } }}>
            {isPositive ? '+' : ''}{change.toFixed(2)} ({pct.toFixed(2)}%)
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default IndexCard;
